import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import "./Nav.css";
const Nav = (props) => {
  const [navbar, setNavbar] = useState(false);
  const [mobile, setMobile] = useState(false);

  const changeBackground = () => {
    if (window.scrollY >= 20) {
      setNavbar(true);
    } else {
      setNavbar(false);
    }
  };

  const showNav = () => {
    setMobile((prevMobile) => !prevMobile);
  };

  window.addEventListener("scroll", changeBackground);

  return (
    <div>
      <header className={navbar ? "bb-color" : props.bg}>
        <nav>
          <div className="logo">
            <NavLink exact to="/">
              <p>IDE Cloud</p>
            </NavLink>
          </div>
          <ul className={mobile ? "nav-links nav-active" : "nav-links"}>
            {/*<li>
              <NavLink exact to="/features" activeStyle={{ color: "#0085cf" }}>
                Features
              </NavLink>
            </li>
            <li>
              <NavLink exact to="/pricing" activeStyle={{ color: "#0085cf" }}>
                Pricing
              </NavLink>
            </li>
            <li>
              <NavLink exact to="/customers" activeStyle={{ color: "#0085cf" }}>
                Customers
              </NavLink>
            </li>*/}
            <li>
              <NavLink exact to="/" activeStyle={{ color: "#0085cf" }}>
                Home
              </NavLink>
            </li>
            <li>
              <NavLink exact to="/blogs" activeStyle={{ color: "#0085cf" }}>
                Blogs
              </NavLink>
            </li>
            <li className="dontshownow">
              <NavLink
                exact
                to="/request-demo"
                activeStyle={{ color: "#0085cf" }}
              >
                Book a Demo
              </NavLink>
            </li>
            <li className="dontshownow">
              <NavLink
                exact
                to="/free-trial"
                activeStyle={{ color: "#0085cf" }}
              >
                Free Trial
              </NavLink>
            </li>

            <NavLink exact to="/request-demo">
              <button type="button" className="btn nav-btn-demo">
                <span>Book a Demo</span>
              </button>
            </NavLink>
            <NavLink exact to="/free-trial">
              <button type="button" className="btn btn-outline-secondary">
                Free Trial
              </button>
            </NavLink>
          </ul>
          <div onClick={showNav} className="burger">
            <div className="line1"></div>
            <div className="line2"></div>
            <div className="line3"></div>
          </div>
        </nav>
      </header>
    </div>
  );
};

export default Nav;
